import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user:null,
    micomercio:false,
    caja:{}
  },
  getters: {
  },
  mutations: {
    micomercio(state,newValue) {
      state.micomercio = newValue
    },
    caja(state,caja) {
      state.caja = caja
    },
    user(state,user) {
      state.user = user
    }
  },
  actions: {
  },
  modules: {
  }
})
